<template>
  <q-toggle
    :value="value"
    dense
    size="3rem"
    color="primary"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <slot/>
  </q-toggle>
</template>

<script>
export default {
  name: 'AppToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .q-toggle {
  &__track {
    height: 2rem;
    border-radius: 10rem;
    opacity: 1;
  }

  &__inner--truthy {
    .q-toggle__thumb {
      left: 26px;
    }
  }

  &__inner {
    width: 3.4rem;
    padding: 0 0;
    height: 0.64em;
  }

  &__thumb {
    top: 4px;
    left: 5px;

    &:after {
      box-shadow: none !important;
      background-color: white !important;
    }
  }
}
</style>
